var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouritedMutualUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouritedMutualUser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-5.4%",
    width: "110.7%",
    height: "110.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouritedMutualUser",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-Copy-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.6989431,15.1358833 L16.4248877,17.352756 C16.3279369,17.4473675 16.2834902,17.5833066 16.3063634,17.7166464 L16.8431018,20.8466242 C16.8906675,21.1216214 16.8186692,21.3901206 16.6401029,21.6014369 C16.4610168,21.8140529 16.2005752,21.9362162 15.9258379,21.9362162 C15.7753432,21.9362162 15.6295272,21.8998271 15.4928083,21.8278288 L12.6817545,20.3499137 C12.5645298,20.2888321 12.4166344,20.2883123 12.2991497,20.3499137 L9.4883559,21.8278288 C9.10159233,22.0310876 8.61787795,21.9307578 8.34080136,21.6014369 C8.16249504,21.3901206 8.09023679,21.1221413 8.13780247,20.8466242 L8.67428097,17.7166464 C8.69715408,17.5835665 8.65270747,17.4473675 8.55575665,17.352756 L6.28170124,15.1361433 C6.02619816,14.8871383 5.93600531,14.5216883 6.04621213,14.1819705 C6.15667887,13.8422528 6.44467217,13.5994859 6.79790584,13.5482813 L9.94087967,13.0915988 C10.0747394,13.0721046 10.1906645,12.9881499 10.2504465,12.8667665 L11.6558434,10.0188038 C11.8136159,9.69884014 12.1338395,9.5 12.4904521,9.5 C12.8473247,9.5 13.1675483,9.69884014 13.3253208,10.0188038 L14.7304578,12.8665065 C14.7902398,12.98789 14.905905,13.0718447 15.0397647,13.0913389 L18.1827385,13.5480214 C18.5362321,13.5994859 18.8239655,13.8419928 18.9344322,14.1817106 C19.044639,14.5214283 18.9544462,14.8868783 18.6989431,15.1358833 Z M21.8904876,9.01366781 L20.6744852,10.1990929 C20.6226428,10.2496844 20.598876,10.3223749 20.6111069,10.3936755 L20.8981162,12.067364 C20.923551,12.2144129 20.8850514,12.3579871 20.7895669,12.470984 C20.6938045,12.5846758 20.5545389,12.65 20.4076291,12.65 C20.3271552,12.65 20.2491832,12.6305417 20.1760757,12.5920422 L18.672925,11.8017588 C18.6102416,11.7690967 18.5311577,11.7688187 18.4683352,11.8017588 L16.9653235,12.5920422 C16.75851,12.7007305 16.4998541,12.6470813 16.3516933,12.470984 C16.2563478,12.3579871 16.2177093,12.2146909 16.2431441,12.067364 L16.5300144,10.3936755 C16.5422453,10.3225139 16.5184784,10.2496844 16.4666361,10.1990929 L15.2506337,9.0138068 C15.1140089,8.88065669 15.0657802,8.68524014 15.1247109,8.50358337 C15.1837807,8.3219266 15.3377789,8.19211219 15.5266631,8.16473164 L17.2073009,7.92053045 C17.2788795,7.91010638 17.340868,7.86521339 17.3728352,7.80030619 L18.124341,6.27741922 C18.2087065,6.1063255 18.3799392,6 18.5706302,6 C18.7614601,6 18.9326928,6.1063255 19.0170582,6.27741922 L19.7684252,7.8001672 C19.8003923,7.86507441 19.8622417,7.90996739 19.9338204,7.92039147 L21.6144582,8.16459265 C21.8034814,8.19211219 21.9573407,8.32178761 22.0164103,8.50344438 C22.0753411,8.68510116 22.0271124,8.8805177 21.8904876,9.01366781 Z",
    id: "Combined-Shape",
    fill: "#10C2E1",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouritedMutualUser);
export default __webpack_public_path__ + "static/media/icFavouritedMutualUser.6071d8f49b77d28fe7e99eb6ffc91453.svg";
export { ForwardRef as ReactComponent };